import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { setClickedFeature, setHoveredFeature } from "../../actions/ui";
import {
  selectClickedFeature,
  selectBasemap,
  selectSidebarIsOpen,
  selectAllRegionContent,
  selectGeoJSON,
} from "../../reducers";
import PropTypes from "prop-types";
import { setSidebarIsOpen, setZoomToNsw } from "../../actions/ui";
import styles from "./sidebar.module.scss";
import { colors } from "../../modules/theme";
import { ChevronDoubleLeft, ChevronDoubleRight } from "../icons/icons";
import ReactGA from "react-ga";

const Sidebar = (props) => {
  const {
    sidebarIsOpen,
    setSidebarIsOpen,
    allRegionContent,
    clickedFeature,
    setClickedFeature,
    setHoveredFeature,
    geojson,
  } = props;
  //eslint-disable-next-line
  const [_viewingProjectIndex, setViewingProjectIndex] = useState(0);

  const title = "Our Functional Economic Regions (FERs)";

  React.useEffect(() => {
    if (clickedFeature) {
      const element = document.getElementById(
        "tab-" + clickedFeature.properties["Functional"]
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [clickedFeature]);

  return (
    <div
      className={`${styles.sidebarContainer} ${
        sidebarIsOpen ? styles.sidebarOpen : styles.sidebarClosed
      }`}
      onClick={() => {
        const sio = !sidebarIsOpen;
        setSidebarIsOpen(sio);
        ReactGA.event({
          category: "REDS map",
          action: "Toggle sidebar",
          label: sio,
        });
      }}
      id="goregional-sidebar"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={styles.projectsSidebar}
        style={{
          backgroundColor: "#fff",
        }}
      >
        <h3
          className={styles.sidebarSectionHeader}
          style={{
            color: colors.sectionHeader,
            marginTop: 0,
          }}
        >
          {title}
        </h3>
        {allRegionContent && (
          <div className={styles.allRegions}>
            <h4>
              Download the Regional Economic Development Strategy documents by
              selecting a region below
            </h4>
            <p>Documents are PDFs between 1MB and 32MB.</p>
            <ul className={styles.allRegionsList}>
              {Object.entries(allRegionContent).map((r, key) => {
                const regionContent = allRegionContent
                  ? allRegionContent[r[0]]
                  : null;

                const strategiesList = regionContent.strategies
                  ? regionContent.strategies.split(";")
                  : [];

                return (
                  <li
                    key={key + r[0]}
                    tabIndex={sidebarIsOpen ? 0 : -1}
                    className={styles.regionListItem}
                    id={"tab-" + r[0]}
                  >
                    <button
                      className={styles.regionButton}
                      onMouseEnter={() => {
                        const f = geojson.features.find(
                          (d) => d.properties["Functional"] === r[0]
                        );
                        setHoveredFeature(f);
                      }}
                      onClick={() => {
                        const f = geojson.features.find(
                          (d) => d.properties["Functional"] === r[0]
                        );
                        setClickedFeature(f);

                        ReactGA.event({
                          category: "REDS map",
                          action: "Click region in sidebar",
                          label: regionContent.region,
                        });
                      }}
                    >
                      {r[0]}
                    </button>

                    {clickedFeature &&
                      r[0] === clickedFeature.properties["Functional"] && (
                        <div className={styles.regionContentContainer}>
                          <h5 className={styles.regionContentHeading}>
                            Links (open in a new tab / window)
                          </h5>
                          <ul>
                            {/* not all have the 2023 link */}
                            {regionContent.link && (
                              <li>
                                <a
                                  href={regionContent.link}
                                  target="_blank"
                                  title={regionContent.title}
                                  type={`application/pdf; length=${regionContent.typeLength}`}
                                >
                                  2023 REDS Update (PDF,{" "}
                                  {regionContent.filesize})
                                </a>
                              </li>
                            )}

                            {regionContent.linkFire && (
                              <li>
                                <a
                                  href={regionContent.linkFire}
                                  type={`application/pdf; length=${regionContent.typeLengthFire}`}
                                  target="_blank"
                                  title={
                                    regionContent.title +
                                    " fire impact addendum"
                                  }
                                >
                                  REDS fire impact addendum (PDF,{" "}
                                  {regionContent.filesizeFire})
                                </a>
                              </li>
                            )}

                            <li>
                              <a
                                href={regionContent.link2018}
                                target="_blank"
                                title={regionContent.title + " 2018 version"}
                                type={`application/pdf; length=${regionContent.typeLength2018}`}
                              >
                                2018 REDS (PDF, {regionContent.filesize2018})
                              </a>
                            </li>
                          </ul>

                          {strategiesList && strategiesList.length > 0 && (
                            <div>
                              <h5 className={styles.regionContentHeading}>
                                2023 REDS Update Strategies
                              </h5>
                              <ul>
                                {strategiesList.map((s, i) => (
                                  <li key={"strategies-list-" + i}>{s}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      <div
        className={styles.sidebarHandle}
        style={{ backgroundColor: "rbga(255, 255, 255, 0.5)" }}
      >
        <button className={styles.sidebarHandleButton}>
          {sidebarIsOpen ? (
            <ChevronDoubleLeft color="#000" width="14px" height="14px" />
          ) : (
            <ChevronDoubleRight color="#000" width="14px" height="14px" />
          )}
        </button>
      </div>
    </div>
  );
};

const featureShape = {
  type: PropTypes.string.isRequired,
  geometry: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
};
const mapStateToProps = (s) => ({
  basemap: selectBasemap(s),
  sidebarIsOpen: selectSidebarIsOpen(s),
  allRegionContent: selectAllRegionContent(s),
  clickedFeature: selectClickedFeature(s),
  geojson: selectGeoJSON(s),
});
const mapDispatchToProps = {
  setSidebarIsOpen,
  setZoomToNsw,
  setClickedFeature,
  setHoveredFeature,
};
Sidebar.propTypes = {
  setSidebarIsOpen: PropTypes.func.isRequired,
  sidebarIsOpen: PropTypes.bool,
  allRegionContent: PropTypes.object,
  setZoomToNsw: PropTypes.func.isRequired,
  clickedFeature: PropTypes.shape(featureShape),
  setClickedFeature: PropTypes.func.isRequired,
  setHoveredFeature: PropTypes.func.isRequired,
  geojson: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js